// removed by extract-text-webpack-plugin
module.exports = {"ClassicSpinner":"ClassicSpinner__ClassicSpinner__21GLv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Loader/ClassicSpinner.css
// module id = 122
// module chunks = 0